import { createContext, useContext } from 'react';

const AppAuthContext = createContext(null);

const defaultContextValue = {
  getGlobalInformation: async () => {},
  clear: () => {},
};

export const AppAuthProvider = AppAuthContext.Provider;

export const useAppAuth = () => {
  const context = useContext(AppAuthContext);
  if (!context) {
    throw new Error('useAppAuth must be used within AppAuthProviderWrapper');
  }
  return context;
};

/**
 * Safe version that falls back to defaults when no provider is present.
 * Used internally by Auth0AuthBridge which mounts before the provider is ready.
 */
export const useAppAuthSafe = () => {
  const context = useContext(AppAuthContext);
  return context ?? defaultContextValue;
};

export default AppAuthContext;
